var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note__add"},[(_vm.adding)?_c('note-form',{attrs:{"note":_vm.note},on:{"cancel":_vm.onCancel,"submit":_vm.onSubmit}}):_c('div',[_c('button',{staticClass:"btn note__btn",on:{"click":function($event){$event.preventDefault();return _vm.onAdd.apply(null, arguments)}}},[_vm._v("Add New")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }